<div class="mainDiv">
    <p></p>
    <!-- <div>
        <span class="needhelp" style="float:right;">
            <a (click)="hotlineSubmit()">{{'Need help with:Manual Diagnosis Instructions?'|translate}}?</a></span>
    </div> -->
    <br>
    <div>
        <p class="para">{{'Manual Diagnosis Text1'|translate}}.</p>
        <ol>
            <li>
                <p>{{'Identify the fault'|translate}}.</p>
            </li>
            <li>
                <p><b>{{'Before'|translate}}</b> {{'the necessary repair has been started, select the fault using this'|translate}} <u>
                        <span class="fora"><b><a (click)="getIdentifyFailure()">{{'Identify Failure'|translate}}</a></b></span></u> {{'page link for the current vehicle session'|translate}}.</p>
            </li>
        </ol>
        <p class="para">{{'This information is important as it is required to generate a'|translate}} <b>{{'Repair Validation Code'|translate}}</b> {{'and
            assist Ford in improving FordEtis IDS diagnostics'|translate}}.</p>
        <p class="para">{{'Note: If the session is no longer open, you may restore it via the'|translate}} <u><a
                    routerLink="/vehiclesession">{{'Vehicle Sessions'|translate}}</a></u> {{'page found under the Vehicle tab'|translate}}.</p>
        <p class="para">{{'Manual Diagnosis Text2'|translate}}.</p>
        <p class="para"></p>
        <ol>
            <li>
                <p class="listitem">{{'Use the'|translate}} <u><a routerLink="/viewssm" target="_blank">{{'Symptom Messages'|translate}}</a></u>
                    {{'tab to look for any'|translate}} <b>{{'Special Service Messages'|translate}}</b> {{'for the customer symptoms selected'|translate}}.</p>
            </li>
            <li>
                <p>{{'Review relevant'|translate}}:</p>
                <ul>
                    <li>
                        <p><u><a routerLink="/tsbsearch">{{'Technical Service Bulletins'|translate}}</a></u></p>
                    </li>
                    <li>
                        <p><u><a routerLink="/workshopmanual">{{'Mechanical Repair Manuals'|translate}}</a></u></p>
                    </li>
                    <li>
                        <p><u><a routerLink="/wiring">{{'Wiring Diagrams'|translate}}</a></u></p>
                    </li>
                    <li>
                        <p><u><a routerLink="/oasisbroadcast">{{'Broadcast Messages'|translate}}</a></u></p>
                    </li>
                </ul>
            </li>
            <li>{{'Manual Diagnosis Text3'|translate}} <u>
                    <a routerLink="/hotline" (click)="hotlineHints()">{{'Hotline Hints and Tips'|translate}}</a></u>{{'and call the'|translate}} <u>
                    <a routerLink="/hotline" (click)="hotlineInfo()">{{'Technical Hotline'|translate}}.</a></u>.</li>
        </ol>
        <p></p>
    </div>
</div>